export default {
  getMessageConfirmation () {
    return {
      cancel: 'Não faça nada',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja desassociar <strong>${this.currentEntity.name}</strong>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/resources/computed.js